export const TYPES_MENU_LIST = {
  COOKIE_POLICY: 'cookiePolicy',
  LEGAL_NOTICE: 'legalNotice',
  PRIVACY_POLICY: 'privacyPolicy',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  WHATSAPP_GROUPS: 'whatsappGroups',
}
